import React, { FunctionComponent } from 'react'

import { GlobalScripts } from '@common/components'
import { ANALYTICS_CONTAINER_ID, LMI_MA_SCRIPT, SC_SITE } from '@common/constants'
import favicon from '@common/images/logmein-favicon.ico'

import { FeatureFlagProvider } from '@common/components/FeatureFlags'
import { useFavicon } from '@common/hooks/useFavicon'
import { LmiProRoutes } from './Routes'
import { ConnectedLmiProTrackingProvider } from './connectedComponents'

const App: FunctionComponent = () => {
    // user will be redirected in this case
    // const unauthUser = window.location.search.includes('?error=unauthenticated_user')

    useFavicon(favicon)

    return (
        <>
            {
                /* !unauthUser && */ <GlobalScripts
                    analyticsProductKey={ANALYTICS_CONTAINER_ID.LMIPRO}
                    lmiMaScriptUrl={LMI_MA_SCRIPT.URL}
                    enableChatBot={false}
                />
            }
            <FeatureFlagProvider siteType={SC_SITE.LOGMEIN}>
                <ConnectedLmiProTrackingProvider>
                    <LmiProRoutes />
                </ConnectedLmiProTrackingProvider>
            </FeatureFlagProvider>
        </>
    )
}

export default App
